import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTheme } from "@mui/material/styles";
import { Autocomplete, Box, Paper, TextField, Typography } from "@mui/material";
import dayjs from 'util/dayjs-init.js';
import localizationKeys from "../../../i18n/localizationKeys.js";
import * as PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import makeStyles from '@mui/styles/makeStyles';
import { SearchIcon } from "../../common/listUtil/searchIcon.jsx";
import { alarmSearch, placeHolder } from "./searchDesign.jsx";

const column = {
  fontSize: "12px",
  fontFamily: "Inter",
  fontWeight: "500",
  color: "#ffffff",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
};

const useStyles = ({ isEnglish, isOperationPage, theme }) =>
  ({
    searchBase: {
      flexGrow: 1,
      // marginLeft: "10px",
      "& .first-child": {
        marginRight: "auto",
      },
      "& .MuiAutocomplete-popper": {
        backgroundColor: "none !important",
      },
      [theme.breakpoints.down('sm')]: {
        width: "100%",
        marginLeft: "0",
      },
    },
    searchIconDiv: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        cursor: "pointer",
      },
    },
    searchIconAdjustment: {
      marginRight: "5px",
    },
    item: {
      //display: "flex",
      alignItems: "left",
      justifyContent: "flex-start",
      width: "100%",
      height: "100%",
      [theme.breakpoints.down('sm')]: {
        display: "block",
        marginBottom: "12px",
      },
    },
    columnName: {
      ...column,
      [theme.breakpoints.up("sm")]: {
        //marginLeft: "auto",
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: "10px !important",
      },
    },
    titleContainer: {
      width: isOperationPage ? "110px" : "80px",
      display: "flex",
      margin: "4px 0px",
      [theme.breakpoints.down('sm')]: {
        width: "100%",
        marginBottom: "12px",
      },
    },
  });

const SearchItem = React.memo(
  ({ isOperationPage, text, setText, autocompleteOptions, i18n, t, resetFunc }) => {
    const theme = useTheme();
    const classes = useStyles({
      isEnglish: i18n.language === "en-US",
      isOperationPage,
      theme,
    });
    const [key, setKey] = useState("");
    const { register, getValues, setValue, watch, reset } = useForm({
      defaultValues: {
        item: "",
      },
    });

    const CustomPaper = ({ children }) => (
      <Paper 
        sx={{
          "& .MuiAutocomplete-listbox": {
            backgroundColor: "#2c3a48",
            color: "white",
            "& :hover": {
              backgroundColor: "rgba(33, 38, 47, 1.0)",
            },
            [theme.breakpoints.down('sm')]: {
              fontSize: "10px !important",
            },
          },
        }}
      >
        {children}
      </Paper>
    );

    const [open, setOpen] = useState(false);
    const AddSearchIcon = () => {
      const SearchIconButtonClick = () => {
        setOpen(true);
      };
      return (
        <div sx={classes.searchIconDiv} onClick={() => SearchIconButtonClick()}>
          <SearchIcon color={"#19B2AB"} />
        </div>
      );
    };

    resetFunc.current = () => {
      reset();
      setKey(dayjs.utc().toString());
    };

    useEffect(() => {
      setValue("item", text);
    }, []);

    useEffect(() => {
      setText(getValues().item);
    }, [watch("item")]);

    return (
      <Box sx={classes.item} key="input-base">
        <Box sx={classes.titleContainer}>
          <Typography sx={classes.columnName} variant="body2">
            {t(
              isOperationPage
                ? localizationKeys.AlarmOperationItem_lower
                : localizationKeys.AlarmName_lower
            )}
          </Typography>
        </Box>
        <Autocomplete
          name="item"
          key={key}
          freeSolo
          open={open}
          onClose={() => setOpen(false)}
          options={autocompleteOptions()}
          {...register("item")}
          onInputChange={(e, v, r) => {
            setValue("item", v);
          }}
          sx={classes.searchBase}
          disableClearable
          slots={{
            paper: CustomPaper,
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              key="input-text"
              sx={{ ...alarmSearch(theme) }}
              onClick={() => setOpen(true)}
              placeholder={t(localizationKeys.Search_lower)}
              variant="standard"
              slotProps={{
                input: {
                  ...params.InputProps,
                  type: "search",
                  endAdornment: <AddSearchIcon />,
                  variant: "standard",
                }
              }}
            />
          )}
        />
      </Box>
    );
  }
);

SearchItem.propTypes = {
  isOperationPage: PropTypes.bool,
  text: PropTypes.string,
  setText: PropTypes.func,
  t: PropTypes.func,
  autocompleteOptions: PropTypes.func,
  i18n: PropTypes.object,
};

export default withTranslation()(SearchItem);
